<template>
  <div class="explore">
    <div class="blue-gradient">
    </div>
    <div class="orange-gradient position-fixed">
    </div>
    <b-row>
      <b-col md="4">
        <div class="bread">
          <span @click="goTop">HOME</span>
          /
          <strong>MODEL PREDICTIVE CONTROL</strong>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <h1>Model Predictive Control</h1>
        <h2>Basic control strategies aren’t enough</h2>
        <p>Although regulatory control provides adequate control in terms of plant safety, it
        rarely achieves optimal control in terms of quality, nor does it operate in the
        most economical fashion.</p>
        <div class="buttons">
          <b-button pill variant="outline-primary" :to="{ name: 'Benefits' }">BENEFITS BY AREA</b-button>
          <b-button pill variant="outline-primary" :to="{ name: 'MPC' }">MPC TECHNOLOGY</b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  methods: {
    goTop () {
      this.$router.push({ name: 'Home' })
    }
  },
  mounted () {
    this.$store.commit('showLogo', true)
  },
  name: 'Explore'
}
</script>

<style lang="scss" scoped>
.explore {
  width: 100%;
  height: 100%;
  padding: 3%;
  background: url('../assets/img/benefits/still.png');
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
